import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift, Copy, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

/** Shown once, right after a customer registers, so the welcome code is impossible to miss. */
export function WelcomeCodeCard({ code, onClose }) {
  const [rules, setRules] = useState(null);
  const { setDrawerOpen } = useCart();

  useEffect(() => {
    api.get("/offers/code").then(({ data }) => setRules(data.welcome || null)).catch(() => {});
  }, []);

  if (!code) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      toast.success("Code copied");
    } catch {
      toast.success(`Your code is ${code}`);
    }
  };

  return (
    <div className="fixed inset-0 z-[90] flex items-end justify-center bg-black/70 p-4 backdrop-blur-sm sm:items-center" data-testid="welcome-code-card">
      <div className="w-full max-w-md overflow-hidden rounded-3xl border border-yellow-300/30 bg-[#12141A]">
        <div className="bg-gradient-to-r from-amber-500 via-yellow-300 to-amber-500 px-5 py-3 text-[#0A0B0E]">
          <p className="flex items-center gap-2 font-display text-base font-extrabold">
            <Gift size={18} /> Welcome to VARSHA SUBLIMATION
          </p>
        </div>

        <div className="space-y-4 p-5">
          <p className="text-sm text-slate-300">
            Aapka registration ho gaya. Pehle order par ye code lagaiye:
          </p>

          <button
            onClick={copy}
            data-testid="welcome-code-copy"
            className="flex w-full items-center justify-between gap-3 rounded-2xl border border-yellow-300/40 bg-yellow-300/10 px-4 py-4"
          >
            <span className="font-mono text-2xl font-extrabold tracking-[0.2em] text-yellow-300">{code}</span>
            <span className="flex items-center gap-1 text-[11px] font-bold uppercase tracking-[0.15em] text-yellow-200">
              <Copy size={13} /> Copy
            </span>
          </button>

          <ol className="space-y-2 text-xs leading-relaxed text-slate-400">
            <li><span className="font-bold text-slate-200">1.</span> Catalogue se products cart me daaliye</li>
            <li>
              <span className="font-bold text-slate-200">2.</span> Cart me "Discount code" box me <span className="font-mono text-yellow-300">{code}</span> likh kar Apply dabaiye
            </li>
            <li>
              <span className="font-bold text-slate-200">3.</span>{" "}
              {rules?.active
                ? `${rules.percent}% ki chhoot turant total me kam ho jayegi (${rules.min_total_text} se upar ke order par, ${rules.days} din ke andar)`
                : "Chhoot turant total me kam ho jayegi"}
            </li>
          </ol>

          <p className="rounded-xl border border-white/10 bg-black/30 p-3 text-[11px] text-slate-500">
            Ye code sirf aapke number ke liye hai aur <span className="text-slate-300">ek hi baar</span> chalega.
            Cart me ye code apne aap bhi dikhega — bhoolne ki zarurat nahi.
            <br />
            Catalogue: <a href="https://sublimationwala.in" className="text-cyan-300 underline" data-testid="welcome-code-site">sublimationwala.in</a>
          </p>

          <div className="flex flex-wrap gap-2">
            <button
              data-testid="welcome-code-shop"
              onClick={() => { onClose(); setDrawerOpen(false); }}
              className="flex flex-1 items-center justify-center gap-2 rounded-full bg-gradient-to-r from-cyan-400 to-fuchsia-500 px-5 py-3 text-sm font-bold text-[#0A0B0E]"
            >
              Shopping shuru kijiye <ArrowRight size={15} />
            </button>
            <button
              data-testid="welcome-code-close"
              onClick={onClose}
              className="rounded-full border border-white/10 px-5 py-3 text-sm text-slate-300 hover:bg-white/5"
            >
              Baad me
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
